export default fetch => {
  if (!!fetch && typeof fetch !== 'function') {
    throw new Error('fetch callback is necessary');
  }

  return {
    async beforeRouteEnter(route, _redirect, next) {
      await fetch(route.params);
      next();
    },
    async beforeRouteUpdate(to, _from, next) {
      await fetch(to.params);
      next();
    },
  };
};
